<template>
<div class="ui segments">

  <div class="ui segment">
    <div class="ui breadcrumb">
      <router-link :to="{name:'home'}" class="section">Sākums</router-link>
      <span class="divider">/</span>
      <div class="active section">Lietošanā esošās preces</div>
    </div>
  </div>

  <div class="ui segment" v-bind:class="{ loading: storeStatus.loading }">
    <table class="ui selectable table orange">
      <thead v-if="!checkClientWidth">
        <tr>
          <th>Prece</th>
          <th>Lietošanā</th>
          <th>Drošības nauda</th>
          <th>Mēneša maksa</th>
          <th>Pēdējo reizi apmaksāts</th>
        </tr>
      </thead>
      <tbody v-if="!checkClientWidth">
        <tr v-for="item in items">
          <td>{{item.goods_name}}</td>
          <td>{{item.no_of_items}} gab.</td>
          <td>{{item.bail_per_item}} &euro;</td>
          <td v-if="item.monthly_payment_vat > 0">{{item.monthly_payment_vat}} &euro;</td>
          <td v-else>Nav</td>
          <td v-if="item.monthly_payment_vat > 0">{{item.last_executed}}</td>
          <td v-else>-</td>
        </tr>
      </tbody>
      <tbody v-if="checkClientWidth">
        <tr v-for="item in items">
          <td>{{item.goods_name}}</td>
          <td>Lietošanā: {{item.no_of_items}} gab.</td>
          <td>Drošības nauda/pud.: {{item.bail_per_item}} &euro;</td>
          <td v-if="item.monthly_payment_vat > 0">Drošības nauda/pud.: {{item.monthly_payment_vat}} &euro;</td>
          <td v-else>Mēneša maksa: Nav</td>
          <td v-if="item.monthly_payment_vat > 0">Izrakstīts rēķins: {{item.last_executed}}</td>
          <td v-else>Izrakstīts rēķins: -</td>
        </tr>
      </tbody>
    </table>

  </div>

</div>
</template>

<script>
export default {

  computed: {
    items() {
      return this.$store.state.rentedGoodsStore.items
    },
    storeStatus() {
      return this.$store.state.rentedGoodsStore.status
    },
    checkClientWidth(){
     return document.documentElement.clientWidth < 768
   },
  },

  activated: function() {
    //preload data
    this.$store.dispatch('loadRentedGoods');
  }
}
</script>



// WEBPACK FOOTER //
// UserRentedGoodsPage.vue?11e17d97